import React, { useCallback, useEffect, useState } from "react"
import { Link } from "react-router-dom"
import { toast } from "react-toastify"

import { getUserOverview, sendKajabiAccessRequest, sendLearnWorldAccessRequest } from "../../requesters/UsersRequester"
import OverviewContent from "./OverviewContent"
import SetItUpModal from "./SetItUpModal"
import SectionRetakeDropdown from "./LiveLife/SectionRetakeDropdown"

function SurveyOverviewPage({ currentUser, baseUrl }) {
  const [userOverview, setUserOverview] = useState([])
  const [inflight, setInflight] = useState(true)
  const [showSpinner, setShowSpinner] = useState(false)
  const unfinishedTenDwcExists = _.get(currentUser, "active_enrolment.is_new_attempt_ten_dwc", true)
  const unfinishedMscExists = _.get(currentUser, "active_enrolment.is_new_attempt_mental_skills", true)
  const unfinishedMfcExists = _.get(currentUser, "active_enrolment.is_new_attempt_matchfit", true)
  const unfinishedLlsExists = _.get(currentUser, "active_enrolment.is_new_attempt_live_life", true)
  const [showSetItUpModal, setShowSetItUpModal] = useState(false)
  const [isSignedUpForKajabi, setIsSignedUpForKajabi] = useState(currentUser.active_enrolment?.kajabi_signed_up)
  const integrationType = currentUser.active_enrolment?.integration_type
  const webhookUrl = currentUser.active_enrolment?.kajabi_webhook_url

  useEffect(() => {
    document.title = "Performance Intelligence Academy | Overview"
  }, [])

  const fetchResults = useCallback(() => {
    getUserOverview(baseUrl, currentUser).then(res => {
      setInflight(false)
      if (Array.isArray(res.response)) {
        setUserOverview(res.response)
      }
      return null
    })
  }, [baseUrl, currentUser])

  useEffect(() => {
    fetchResults()
  }, [fetchResults])

  useEffect(() => {
    if (!inflight && !currentUser?.is_program_active) {
      window.location.href = "/enrol"
    }
  }, [inflight, currentUser])

  const kajabiHandler = () => {
    window.open(currentUser.active_enrolment.offer_redirect_url, "_blank")
  }

  const getStartedHandler = () => {
    sendKajabiAccessRequest(baseUrl, currentUser).then(res => {
      if (res.response?.status === "ok") {
        setIsSignedUpForKajabi(true)
        window.open(currentUser.active_enrolment.offer_redirect_url, "_blank")
      }
      return res
    }).catch(err => toast.error(`${err}`))
  }

  const getStartedLearnWorldHandler = () => {
    setShowSpinner(true)
    sendLearnWorldAccessRequest(baseUrl, currentUser.program_id, currentUser)
      .then(res => {
        if (res.response?.status === "ok") {
          setShowSpinner(false)
          window.open(res.response.json.learn_world.url, "_blank")
        }
        return res
      })
      .catch(err => {
        setShowSpinner(false)
        const errorMessages = err.response?.data?.errors
        if (!errorMessages) {
          toast.error("Something went wrong")
          return
        }

        errorMessages.forEach(error => {
          toast.error(`${error.detail}`)
        })
      })
  }

  if (inflight || !currentUser?.is_program_active) {
    return (
      <div className="dashboard-body content">
        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "calc(100vh - 72px)" }}>
          <div className="spinner-border" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      </div>
    )
  }

  const continueStartBtnHandler = calculator_type => {
    if ((!unfinishedTenDwcExists && (calculator_type === "10DWC")) || (!unfinishedMscExists && (calculator_type === "mental_skills")) || (!unfinishedMfcExists && (calculator_type === "matchfit")) || (!unfinishedLlsExists && (calculator_type === "live_life"))) {
      return "Continue Survey"
    }
    return "Start Survey"
  }

  const programBodyFooter = (integrationType === "kajabi" && !!webhookUrl) && (
    // eslint-disable-next-line jsx-a11y/anchor-is-valid
    <a className="text-nowrap pointer" onClick={() => setShowSetItUpModal(true)}>Need Help?</a>
  )

  const digitalContentAction = (
    <>
      {integrationType === "learn_world" && (
        <button
          className="btn btn-main btn-sm text-nowrap ml-md-auto align-self-md-center"
          type="button"
          onClick={showSpinner ? null : getStartedLearnWorldHandler}
          disabled={showSpinner}>
          {showSpinner ? (
            <>
              <span className="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
              Loading...
            </>
          ) : (
            "Take me There"
          )}
        </button>
      )}

      {integrationType === "kajabi" && (
        isSignedUpForKajabi ? (
          <button
            className="btn btn-main btn-sm text-nowrap ml-md-auto align-self-md-center"
            type="button"
            onClick={kajabiHandler}>
            Take me There
          </button>
        ) : (
          <button
            className="btn btn-main btn-sm text-nowrap ml-md-auto align-self-md-center"
            type="button"
            onClick={() => setShowSetItUpModal(true)}>
            Set it up
          </button>
        )
      )}
      <SetItUpModal
        show={showSetItUpModal}
        currentUser={currentUser}
        baseUrl={baseUrl}
        getStartedHandler={getStartedHandler}
        onHide={() => {
          setShowSetItUpModal(false)
        }} />
    </>
  )

  const renderCalculatorActions = ({
 overview, content, dashboardHref, isV2
}) => {
    const showPqRetake = isV2 && !!currentUser.active_enrolment?.live_life_latest_submitted_id
    return (
      <>
        {!!overview?.calculator_results?.length && <Link className="btn btn-sm btn-outline-main" to={dashboardHref}>View</Link>}
        {showPqRetake && (
          <SectionRetakeDropdown baseUrl={baseUrl} enrolment={currentUser.active_enrolment} />
        )}
        <Link className="btn btn-sm btn-main" to={content.surveyIntroHref}>{continueStartBtnHandler(overview.calculator_type)}</Link>
      </>
    )
  }

  return (
    <OverviewContent
      firstname={currentUser.firstname}
      organisationName={currentUser.organisation_info?.name}
      programName={currentUser.active_enrolment?.program_name}
      programHeader={currentUser.active_enrolment?.program_header}
      programBody={currentUser.active_enrolment?.program_body}
      integrationType={integrationType}
      overviews={userOverview}
      programBodyFooter={programBodyFooter}
      digitalContentAction={digitalContentAction}
      renderCalculatorActions={renderCalculatorActions} />
  )
}

export default SurveyOverviewPage
